import React from 'react';
import { Button } from '@sezzle/sezzle-mui';
import { ButtonLink as ButtonLinkProps } from './types/types';
import { setPrefix } from '../../utils/helpers';
import { defaultLocale } from '../types/constants';
import { CTASelections } from '../types/enums';

// passing in props, instead of being more declarative due to my poor field naming of function :)
const ButtonLink = (props: Partial<ButtonLinkProps>) => {
  const {
    node_locale, url, style, displayText,
  } = props;

  const localePrefix = node_locale && node_locale === defaultLocale ? '' : `/${node_locale?.toLowerCase()}`;
  const buttonStyle = style === CTASelections.PrimaryButton ? 'contained' : 'outlined' || 'contained';
  const setURL = !url?.startsWith('/') ? setPrefix(props.function, url) : `${localePrefix}${url}` || `${localePrefix}${url}`;

  return (
    <Button
      data-testid="buttonAnchor"
      data-component-type="button-styled-link"
      href={setURL}
      color="secondary"
      variant={buttonStyle}
      className="trk-ga"
      size="large"
    >
      {displayText}
    </Button>
  );
};

export default ButtonLink;
